/**
 * スクロールアニメーション制御モジュール
 *
 * - 指定クラスを持つ要素に対し、スクロール位置に応じてアニメーション用クラスを付与
 * - .js-scroll クラスのリンクにスムーススクロール機能を付与
 *
 * @example
 *   const animator = new ScrollAnimator();
 *   animator.init();
 *
 * 注意:
 * - 対象要素のクラス名やHTML構造が変わる場合はセレクタも要調整
 * - スムーススクロールのオフセットはSP/PCで自動切替
 */
export class ScrollAnimator {
	constructor() {
		this.targets = document.querySelectorAll(
			'.slideL, .slideR, .fadeIn, .slideU, .slideD'
		);
		this.scrollLinks = document.querySelectorAll('.js-scroll');
	}

	/**
	 * 初期化処理。アニメーション・スムーススクロールのイベント登録
	 */
	init() {
		if (this.targets.length) {
			window.addEventListener('scroll', () => this.animate());
			window.addEventListener('load', () => this.animate());
		}

		if (this.scrollLinks.length) {
			this.scrollLinks.forEach((el) =>
				el.addEventListener('click', (e) => this.smoothScroll(e, el))
			);
		}
	}

	/**
	 * スクロール位置に応じて対象要素にアニメーション用クラスを付与
	 */
	animate() {
		const scroll = window.scrollY;
		const windowHeight = window.innerHeight;
		this.targets.forEach((el) => {
			const elemPos = el.getBoundingClientRect().top + scroll;
			if (scroll >= elemPos - windowHeight) {
				el.classList.add('anime');
			}
		});
	}

	/**
	 * .js-scrollリンクのクリック時にスムーススクロールを実行
	 * @param {Event} e クリックイベント
	 * @param {Element} el クリックされたリンク要素
	 */
	smoothScroll(e, el) {
		e.preventDefault();
		const hash = el.hash;
		const target = document.querySelector(hash);
		if (!target) return;
		const offsetY = window.innerWidth <= 768 ? -45 : 0;
		const targetY =
			target.getBoundingClientRect().top + window.scrollY + offsetY;
		window.scrollTo({ top: targetY, behavior: 'smooth' });
	}
}
